module.exports = __webpack_public_path__ + "static/media/link.14b9de90.svg";